/* Custom Suit page — configurator, comparison table link and video players. */
(function () {
  'use strict';
  if (window.__csLoaded) return;
  window.__csLoaded = true;

  var norm = function (s) { return String(s || '').trim().toLowerCase(); };

  function initConfigurator(root) {
    if (root.__csReady) return;
    var dataEl = root.querySelector('[data-cs-data]');
    if (!dataEl) return;
    root.__csReady = true;
    var D = JSON.parse(dataEl.textContent);
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var fmt;
    try {
      var nf0 = new Intl.NumberFormat(D.locale || undefined, { style: 'currency', currency: D.currency || 'GBP', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      var nf2 = new Intl.NumberFormat(D.locale || undefined, { style: 'currency', currency: D.currency || 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 });
      fmt = function (cents) { return (cents % 100 === 0 ? nf0 : nf2).format(cents / 100); };
    } catch (e) { fmt = function (cents) { return (cents / 100).toFixed(2); }; }

    var pay = D.payment.enabled ? (D.payment.default === 'full' ? 'full' : 'deposit') : 'full';
    var groups = $$('[data-cs-group]').map(function (fs) {
      var btns = Array.prototype.slice.call(fs.querySelectorAll('.cs-opt'));
      var def = btns.filter(function (b) { return b.hasAttribute('data-default'); })[0] || btns[0];
      return { el: fs, prop: fs.getAttribute('data-prop'), vopt: fs.getAttribute('data-variant-option'), preview: fs.getAttribute('data-preview') === 'true', btns: btns, val: def ? def.getAttribute('data-value') : '' };
    });
    var addons = $$('[data-cs-addon]');

    var optIndex = function (name) {
      var n = norm(name);
      for (var i = 0; i < D.options.length; i++) if (norm(D.options[i]) === n) return i;
      return -1;
    };
    var payIdx = D.payment.enabled ? optIndex(D.payment.option) : -1;
    var payValue = function (mode) { return mode === 'deposit' ? D.payment.deposit : D.payment.full; };

    // Find the main suit variant for the current choices and a payment mode
    function findVariant(mode) {
      var want = {};
      groups.forEach(function (g) { if (g.vopt) { var i = optIndex(g.vopt); if (i > -1) want[i] = norm(g.val); } });
      if (payIdx > -1) want[payIdx] = norm(payValue(mode));
      return D.variants.filter(function (v) {
        for (var k in want) if (norm(v.options[k]) !== want[k]) return false;
        return true;
      })[0] || null;
    }
    // Find an upgrade variant by name and payment mode
    function findUpgrade(name, mode) {
      if (!name) return null;
      var n = norm(name), pv = norm(payValue(mode));
      var hits = D.upgrades.filter(function (v) { return v.options.some(function (o) { return norm(o) === n; }); });
      if (hits.length > 1 && D.payment.enabled) {
        var withPay = hits.filter(function (v) { return v.options.some(function (o) { return norm(o) === pv; }); });
        if (withPay.length) return withPay[0];
      }
      return hits[0] || null;
    }

    function selection() {
      var full = findVariant('full'), dep = pay === 'deposit' ? findVariant('deposit') : full;
      var lines = [], items = [], total = 0, due = 0, props = {};
      var vchoices = groups.filter(function (g) { return g.vopt; }).map(function (g) { return g.val.toLowerCase(); });
      if (full) {
        lines.push([D.text.base + (vchoices.length ? ' (' + vchoices.join(', ') + ')' : ''), full.price]);
        total += full.price; due += dep ? dep.price : full.price;
      }
      groups.forEach(function (g) {
        props[g.prop] = g.val;
        var btn = g.btns.filter(function (b) { return b.getAttribute('data-value') === g.val; })[0];
        var upName = btn && btn.getAttribute('data-upgrade');
        if (upName) {
          var uf = findUpgrade(upName, 'full'), ud = findUpgrade(upName, pay);
          if (uf) { lines.push([g.val + ' (' + g.prop.toLowerCase() + ')', uf.price]); total += uf.price; due += (ud || uf).price; items.push({ id: (ud || uf).id, name: upName }); }
        }
      });
      addons.forEach(function (a) {
        if (!a.checked) return;
        var n = a.getAttribute('data-upgrade'), uf = findUpgrade(n, 'full'), ud = findUpgrade(n, pay);
        if (uf) { lines.push([a.getAttribute('data-label'), uf.price]); total += uf.price; due += (ud || uf).price; items.push({ id: (ud || uf).id, name: n }); }
      });
      return { main: dep, full: full, lines: lines, items: items, total: total, due: due, props: props };
    }

    function render() {
      groups.forEach(function (g) {
        g.btns.forEach(function (b) {
          var v = b.getAttribute('data-value');
          b.setAttribute('aria-checked', String(v === g.val));
          var small = b.querySelector('[data-cs-delta]');
          if (!small) return;
          var up = b.getAttribute('data-upgrade');
          if (up) { var u = findUpgrade(up, 'full'); small.textContent = u && u.price ? '+' + fmt(u.price) : ''; }
          else if (g.vopt) {
            var keep = g.val; g.val = v; var me = findVariant('full'); g.val = g.btns[0].getAttribute('data-value'); var first = findVariant('full'); g.val = keep;
            b.disabled = !me;
            small.textContent = me && first && me.price > first.price ? '+' + fmt(me.price - first.price) : (b === g.btns[0] && g.btns.some(function (x) { var k2 = g.val; g.val = x.getAttribute('data-value'); var vv = findVariant('full'); g.val = k2; return vv && first && vv.price > first.price; }) ? 'Included' : '');
          }
        });
      });
      addons.forEach(function (a) {
        var u = findUpgrade(a.getAttribute('data-upgrade'), 'full');
        var el = a.parentNode.querySelector('[data-cs-addon-price]');
        if (el) el.textContent = u ? '+' + fmt(u.price) : '';
        a.disabled = !u;
      });

      var S = selection(), later = S.total - S.due;
      var priceEl = $('[data-cs-price]'); if (priceEl) priceEl.textContent = fmt(S.total);
      $$('[data-cs-pay] button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pay') === pay)); });
      var pf = $('[data-cs-payfull]'); if (pf) pf.textContent = fmt(S.total) + ' today';
      if (D.payment.enabled) {
        var saved = pay; pay = 'deposit'; var Sd = selection(); pay = saved;
        var pd = $('[data-cs-paydep]'); if (pd) pd.textContent = fmt(Sd.due) + ' today · rest after design approval';
      }
      var html = S.lines.map(function (l) { return '<div class="cs-r"><span>' + esc(l[0]) + '</span><span class="cs-num">' + fmt(l[1]) + '</span></div>'; }).join('');
      html += '<div class="cs-r cs-tot"><span>' + esc(D.text.total) + '</span><span class="cs-num">' + fmt(S.total) + '</span></div>';
      if (pay === 'deposit' && later > 0) {
        html += '<div class="cs-r cs-due"><span>' + esc(D.text.dueToday) + '</span><span class="cs-num">' + fmt(S.due) + '</span></div>';
        html += '<div class="cs-r"><span>' + esc(D.text.dueLater) + '</span><span class="cs-num">' + fmt(later) + '</span></div>';
      }
      var sum = $('[data-cs-summary]'); if (sum) sum.innerHTML = html;
      var add = $('[data-cs-add]');
      if (add) {
        add.textContent = (pay === 'deposit' && later > 0 ? D.text.addDeposit : D.text.addFull).replace('[price]', fmt(S.due));
        add.disabled = !S.main;
      }
      var md = $('[data-cs-mdue]'); if (md) md.textContent = fmt(S.due);
      // Price box (Your build / Due today)
      var isDep = pay === 'deposit' && later > 0;
      var bd = $('[data-cs-boxdue]'); if (bd) bd.textContent = fmt(isDep ? S.due : S.total);
      var bl = $('[data-cs-boxlabel]'); if (bl) bl.textContent = bl.getAttribute(isDep ? 'data-dep' : 'data-full') || '';
      var bn = $('[data-cs-boxnote]'); if (bn) bn.textContent = isDep ? (bn.getAttribute('data-later') || '').replace('[price]', fmt(later)) : (bn.getAttribute('data-full') || '');
      var live = $('[data-cs-live]');
      if (live) live.innerHTML = groups.filter(function (g) { return g.preview; }).map(function (g) { return '<span>' + esc(g.val) + '</span>'; }).join('');
      groups.forEach(function (g) { document.dispatchEvent(new CustomEvent('cs:changed', { detail: { prop: g.prop, vopt: g.vopt, value: g.val } })); });
      return S;
    }

    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    groups.forEach(function (g) {
      g.btns.forEach(function (b) { b.addEventListener('click', function () { g.val = b.getAttribute('data-value'); render(); }); });
    });
    addons.forEach(function (a) { a.addEventListener('change', render); });
    $$('[data-cs-pay] button').forEach(function (b) { b.addEventListener('click', function () { pay = b.getAttribute('data-pay'); render(); }); });

    // Comparison table → select a value
    document.addEventListener('cs:select', function (e) {
      var d = e.detail || {};
      groups.forEach(function (g) {
        if (norm(g.prop) === norm(d.group) || norm(g.vopt) === norm(d.group)) {
          var hit = g.btns.filter(function (b) { return norm(b.getAttribute('data-value')) === norm(d.value); })[0];
          if (hit && !hit.disabled) { g.val = hit.getAttribute('data-value'); render(); }
        }
      });
    });

    // Add to cart
    var busy = false;
    function addToCart() {
      if (busy) return;
      var S = selection();
      if (!S.main) return;
      busy = true;
      var btns = $$('[data-cs-add],[data-cs-add-mobile]');
      btns.forEach(function (b) { b.disabled = true; });
      var err = $('[data-cs-err]'); if (err) err.hidden = true;
      var build = 'CS-' + Date.now().toString(36).toUpperCase();
      var props = {};
      for (var k in S.props) props[k] = S.props[k];
      if (D.payment.enabled) {
        props['Payment'] = pay === 'deposit' ? D.payment.deposit : D.payment.full;
        props['Order total'] = fmt(S.total);
        if (pay === 'deposit' && S.total > S.due) props['Balance after design approval'] = fmt(S.total - S.due);
      }
      props['Build ref'] = build;
      var items = [{ id: S.main.id, quantity: 1, properties: props }];
      S.items.forEach(function (it) { items.push({ id: it.id, quantity: 1, properties: { 'For suit': build } }); });
      var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
      // One suit build per cart: remove any earlier build (suit + its upgrades) so nobody pays twice
      var clear = !D.replacePrevious ? Promise.resolve() : fetch(D.cartJsUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .then(function (cart) {
          var upd = {}, n = 0;
          (cart.items || []).forEach(function (it) {
            var p = it.properties || {};
            if (it.product_id === D.productId || (D.upgradesId && it.product_id === D.upgradesId) || p['Build ref'] || p['For suit']) { upd[it.key] = 0; n++; }
          });
          if (!n) return;
          return fetch(D.cartUpdateUrl, { method: 'POST', headers: J, body: JSON.stringify({ updates: upd }) });
        })
        .catch(function () {});
      clear.then(function () { return fetch(D.cartAddUrl, { method: 'POST', headers: J, body: JSON.stringify({ items: items }) }); })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () { window.location.href = D.afterAdd === 'checkout' ? '/checkout' : D.cartUrl; })
        .catch(function () {
          if (err) { err.textContent = D.text.error; err.hidden = false; }
          busy = false; btns.forEach(function (b) { b.disabled = false; });
        });
    }
    $$('[data-cs-add],[data-cs-add-mobile]').forEach(function (b) { b.addEventListener('click', addToCart); });
    // Coming back with the browser back button: unlock the buttons again
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { busy = false; $$('[data-cs-add],[data-cs-add-mobile]').forEach(function (b) { b.disabled = !selection().main; }); }
    });

    render();
  }


  // Carousel: native scroll-snap track + arrows, counter, thumbnails, swipe and optional autoplay
  function initCarousel(root) {
    if (root.__csReady) return;
    var track = root.querySelector('[data-cs-track]');
    if (!track) return;
    root.__csReady = true;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-cs-slide]'));
    var prev = root.querySelector('[data-cs-prev]'), next = root.querySelector('[data-cs-next]');
    var count = root.querySelector('[data-cs-count]');
    var progress = root.querySelector('[data-cs-progress]');
    var thumbsBox = root.parentNode.querySelector('[data-cs-thumbs]');
    var thumbs = thumbsBox ? Array.prototype.slice.call(thumbsBox.querySelectorAll('button')) : [];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;
    if (slides.length < 2) { root.classList.add('cs-car--single'); }

    function step() { return slides[0] ? slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
    function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function go(i, smooth) {
      i = Math.max(0, Math.min(i, maxIndex()));
      track.scrollTo({ left: slides[i] ? slides[i].offsetLeft - slides[0].offsetLeft : 0, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
    }
    function update() {
      var i = Math.round(track.scrollLeft / step());
      i = Math.max(0, Math.min(i, slides.length - 1));
      current = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      if (progress) { var max = track.scrollWidth - track.clientWidth; progress.style.width = (max > 0 ? Math.max(8, (track.scrollLeft / max) * 100) : 100) + '%'; }
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.setAttribute('aria-pressed', String(on));
        if (on && thumbsBox.scrollWidth > thumbsBox.clientWidth) {
          var l = t.offsetLeft - thumbsBox.clientWidth / 2 + t.clientWidth / 2;
          thumbsBox.scrollTo({ left: l, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      slides.forEach(function (s, k) {
        if (k !== i) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
      });
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { stop(); go(current - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(current + 1 > maxIndex() ? 0 : current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { stop(); go(parseInt(t.getAttribute('data-i'), 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(current - 1); }
    });
    window.addEventListener('resize', function () { go(current, false); update(); });

    // Autoplay (pauses on hover, focus, touch, or when off screen)
    var secs = parseInt(root.getAttribute('data-autoplay'), 10) || 0, timer = null, visible = true, hold = false;
    function tick() { if (!visible || hold || document.hidden) return; go(current + 1 > maxIndex() ? 0 : current + 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (secs > 0 && !reduce && slides.length > 1) {
      timer = setInterval(tick, secs * 1000);
      root.addEventListener('mouseenter', function () { hold = true; });
      root.addEventListener('mouseleave', function () { hold = false; });
      root.addEventListener('focusin', function () { hold = true; });
      track.addEventListener('touchstart', stop, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(root);
    }
    root.__csGo = go;
    update();
  }

  // Comparison table: header click selects; highlights current choice
  function initTable(t) {
    if (t.__csReady) return;
    t.__csReady = true;
    var group = t.getAttribute('data-cs-link');
    t.querySelectorAll('th[data-col]').forEach(function (th) {
      if (!group) return;
      th.style.cursor = 'pointer';
      th.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('cs:select', { detail: { group: group, value: th.getAttribute('data-col') } })); });
    });
    document.addEventListener('cs:changed', function (e) {
      var d = e.detail || {};
      if (!group || (norm(d.prop) !== norm(group) && norm(d.vopt) !== norm(group))) return;
      t.querySelectorAll('[data-col]').forEach(function (c) { c.classList.toggle('cs-on', norm(c.getAttribute('data-col')) === norm(d.value)); });
    });
  }

  // Click-to-play videos (cover first, player loads only on click). Inline or in a popup.
  var lb = null;
  function closeLightbox() {
    if (!lb) return;
    var el = lb; lb = null;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('cs-lb-lock');
    el.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
    setTimeout(function () { el.remove(); }, 200);
    if (el.__from) try { el.__from.focus(); } catch (e) {}
  }
  function openLightbox(tpl, from) {
    closeLightbox();
    var ratio = (tpl.getAttribute('data-ratio') || '16 / 9').split('/');
    var r = (parseFloat(ratio[0]) || 16) / (parseFloat(ratio[1]) || 9);
    var el = document.createElement('div');
    el.className = 'cs-lb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', from.getAttribute('aria-label') || 'Video');
    el.innerHTML = '<button type="button" class="cs-lb-x" aria-label="Close video">&times;</button><div class="cs-lb-box"></div>';
    var box = el.querySelector('.cs-lb-box');
    box.style.setProperty('--lb-ratio', ratio.join('/'));
    box.style.setProperty('--lb-r', String(r));
    box.appendChild(tpl.content.cloneNode(true));
    el.__from = from;
    el.addEventListener('click', function (e) { if (e.target === el || e.target.closest('.cs-lb-x')) closeLightbox(); });
    document.body.appendChild(el);
    document.documentElement.classList.add('cs-lb-lock');
    lb = el;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    el.querySelector('.cs-lb-x').focus();
    var v = box.querySelector('video');
    if (v) { v.controls = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  var prevObs = null;
  function previewOk() {
    var c = navigator.connection;
    if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return false;
    return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function initVideos(scope) {
    scope.querySelectorAll('[data-cs-vposter]').forEach(function (btn) {
      if (btn.__csReady) return;
      btn.__csReady = true;
      btn.addEventListener('click', function () {
        var box = btn.parentNode;
        var tpl = box.querySelector('template');
        if (!tpl) return;
        if (btn.hasAttribute('data-popup')) { openLightbox(tpl, btn); return; }
        box.appendChild(tpl.content.cloneNode(true));
        btn.remove();
        var v = box.querySelector(':scope > video');
        if (v) { v.controls = true; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      });
    });
    // Silent cover previews: load and play only while on screen
    var prevs = scope.querySelectorAll('[data-cs-vprev]');
    if (!prevs.length || !previewOk() || !('IntersectionObserver' in window)) return;
    if (!prevObs) prevObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (!v.src) { v.src = v.getAttribute('data-src'); v.addEventListener('playing', function () { v.classList.add('is-on'); }); }
          v.muted = true;
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.35 });
    prevs.forEach(function (v) { if (!v.__csObs) { v.__csObs = true; prevObs.observe(v); } });
  }

  function boot(scope) {
    scope = scope || document;
    // Tables first so they hear the configurator's first "changed" event
    document.querySelectorAll('[data-cs-link]').forEach(initTable);
    scope.querySelectorAll('[data-cs-car]').forEach(initCarousel);
    scope.querySelectorAll('[data-cs-config]').forEach(initConfigurator);
    initVideos(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
